"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceGmailDivs = void 0;

var _SanitizeConfiguration = require("../sanitizers/SanitizeConfiguration");

var replaceGmailDivs = function replaceGmailDivs(_ref) {
  var node = _ref.node,
      node_name = _ref.node_name;

  if (node_name === 'div' && node && node.classList && node.classList.contains('gmail_default')) {
    var span = _SanitizeConfiguration.secureDocument.createElement('span');

    Object.keys(node.attributes).forEach(function (key) {
      var attribute = node.attributes[key];
      span.setAttribute(attribute.nodeName, attribute.nodeValue);
    });
    span.innerHTML = node.innerHTML.trim();
    return {
      node: span
    };
  }

  return null;
};

exports.replaceGmailDivs = replaceGmailDivs;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/replaceGmailDivs.js
// module id = 815
// module chunks = 209 210 211 212